// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5":"ceb1ccc6ded13e38","410":"bbe8ec71e28b1b74"}[chunkId] + ".js";
};